module.exports = __webpack_public_path__ + "img/AcmeElevators.0f7655cb.png";